import React from 'react'
import WithGlobalNav from '@groovehq/internal-design-system/lib/components/GlobalNav/WithGlobalNav/WithGlobalNav'
import GlobalNav from 'components/App/DesktopView/Layout/GlobalNav'
import TopNav from 'components/App/DesktopView/Layout/TopNav'
import AppNotices from 'components/AppNotices'

import ErrorInnerContent from './ErrorInnerContent'

const ErrorContent = ({
  EmptyComponent,
  isEmpty,
  globalNavActive,
  canUseLiveChatFeature,
}) => {
  return (
    <>
      <TopNav active="Conversations" />
      <WithGlobalNav
        globalNav={<GlobalNav active={globalNavActive} />}
        topContent={<AppNotices />}
      >
        <ErrorInnerContent
          EmptyComponent={EmptyComponent}
          isEmpty={isEmpty}
          canUseLiveChatFeature={canUseLiveChatFeature}
        />
      </WithGlobalNav>
    </>
  )
}

export default ErrorContent
